export const getCenterCoordinates = () => {
  const center: any = {
    lat: 36.3596332,
    lng: 138.3303327
  }
  return center
}
export const getDefaultZoomLevel = () => {
  const zoom: number = 14
  return zoom
}
